import React, { useEffect, useState } from "react";
import {
  Link,
  Outlet,
  redirect,
  useLoaderData,
  useLocation,
} from "react-router-dom";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";


export const SettingsContainer = () => {
  const { doctor, apiKeys } = useLoaderData();
  const location = useLocation();
  const isAdmin = doctor.access === "admin";

  console.log("ha", apiKeys);
  

  const tabs = [
    {
      id: 1,
      title: "Update Personal Information",
      name: "Settings",
      href: `/dashboard/settings/personal-info`,
    },
    isAdmin && {
      id: 2,
      title: "Treatment Page Setup",
      name: "Treatment page setup",
      href: `/dashboard/settings/treatment-setup`,
    },
    isAdmin && {
      id: 3,
      title: "Theme and Appearance",
      name: "Theme and appearance",
      href: `/dashboard/settings/theme`,
    },
    apiKeys.length > 0 && {
      id: 4,
      title: "API Keys and Documentation",
      name: "API Keys and Documentation",
      href: `/dashboard/settings/apis`,
    },
  ];


  return (
    <div className={`max-h-[100vh] bg-white overflow-y-scroll scrollbar-hide`}>
      <div className="sticky left-0 right-0 top-0 z-10">
        <div className="bg-[#fafafa] px-10 py-5">
          <p className="text-[18px] font-medium select-none">
            {tabs.find((item) => location.pathname.includes(item.href))?.title || 'Settings'}
          </p>
        </div>

        {isAdmin && (
          <div className="bg-[#fafafa] px-7 flex border-t border-b overflow-x-scroll scrollbar-hide whitespace-nowrap">
            {tabs.map((item) => (
              <Link
                to={item.href}
                key={item.id}
                className={`${location.pathname.includes(item.href)
                    ? "bg-[#00b0ad0d] border-primary text-black font-medium"
                    : "font-medium text-gray-800 border-b-transparent"
                  } border-t-[3px] border-t-transparent border-b cursor-pointer p-3 text-[13px] select-none capitalize`}
              >
                {item.name}
              </Link>
            ))}
            
          </div>
        )}
      </div>
      <Outlet />
    </div>
  );
};
